import React from "react";
import { UserHelper, ApiHelper, ArrayHelper } from "../helpers";
import { Link } from "react-router-dom";
import UserContext from "../UserContext";


interface Props {
  location: any
}


export const Header = (props: Props) => {

  const [showMenu, setShowMenu] = React.useState(false);

  const handleMenuClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowMenu(!showMenu);
  }

  const context = React.useContext(UserContext);

  const pickDepartment = (departmentId: number) => {
    UserHelper.currentDepartment = ArrayHelper.getOne(UserHelper.departments, "id", departmentId);
    ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
    UserHelper.departmentChanged = true;
    context.setUserName(UserHelper.currentDepartment.id.toString());
  }

  const getDepartmentMenu = () => {
    if (showMenu) {
      const accountList: JSX.Element[] = [];
      UserHelper.departments.forEach(d => {
        const departmentId = d.id;
        accountList.push(<a href="about:blank" onClick={(e) => { e.preventDefault(); pickDepartment(departmentId) }}><i className="fas fa-user"></i> {d.name}</a>);
      });

      return (<div id="userMenu">
        <div className="label divider">Switch Account</div>
        <div id="userAccounts">{accountList}</div>
        <Link to="/settings/"><i className="fas fa-cog"></i> Settings</Link>
        <Link to="/logout" className="divider"><i className="fas fa-lock"></i> Logout</Link>
      </div>);
    }
  }


  const getHeaderLink = () => {
    return (<a href="about:blank" onClick={handleMenuClick}>
      <i className="fas fa-user"></i> &nbsp;
      {UserHelper.currentDepartment.name} &nbsp;
      <i className="fas fa-caret-down"></i>
    </a>)
  }

  React.useEffect(() => { if (showMenu) setShowMenu(false) }, [props.location]) //eslint-disable-line

  return (
    <>
      <nav id="pageHeader" className="navbar navbar-expand navbar-dark fixed-top bg-dark">
        <a className="navbar-brand" href="/" style={{ paddingTop: 0, paddingBottom: 0 }}><img src="/images/logo.png" style={{ paddingTop: 0, paddingBottom: 0 }} alt="logo" /></a>
        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav mr-auto">
          </ul>
          <div className="navbar-nav ml-auto">
            {getHeaderLink()}
          </div>
        </div>
      </nav>
      {getDepartmentMenu()}
      <div style={{ height: 66 }}></div>
    </>
  );
};